import baptism from '../images/baptism.jpg'

css .who-we-are-page
	min-height:100vh
	d:flex
	fld:column
	.shape-header
		h:300px
	.who-we-are
		flg: 1

tag who-we-are-page
	<self.who-we-are-page>
		<shape-header title="About Us" image=baptism>
		<text-block.who-we-are title="Who We Are">
			<p[mb:1em]>
				"Grace Lutheran is a multi-generational community of faith uniquely situated in the heart of downtown San Antonio. We are a place where you can come exactly as you are and be celebrated and welcomed. We are a place where you can find peace, refuge and purpose. We are a place where you can find others to accompany you on your journey of faith."
			<p[mb:1em]>
				"Our worship is anchored in the rich tradition of Lutheranism and is formed around word and table but is inspired by the Spirit and interspersed with fresh music, liturgies and inspiration. All are welcome at the Lord’s Table at Grace – Jesus sets the guest list for communion and "
				<i[fw:bold]> "all"
				" are invited. "
			<p[mb:1em]>
				"We are a proud part of the "
				<a href="https://elca.org" target="_blank"> "Evangelical Lutheran Church in America (ELCA)"
				" Our youth are crucial to our community – each Grace kid is immersed in love and Christian formation. Young and old alike join together in leadership."
			<p[mb:1em]>
				"If you have any questions about the particularities of Grace please reach out to our Office Manager or Pastor. May God’s grace fill your heart to overflowing – you are loved!"
			<div.buttons[d:flex p:1em jc:space-between]>
				<a.btn.btn-warning[flb:50% mr:1em] href="mailto:office@gracesa.org" target="_blank"> "Office Manager"
				<a.btn.btn-danger[flb:50%] href="mailto:pastor@gracesa.org" target="_blank"> "Pastor"
		<footer-section>